import { EventEmitter, Injectable } from '@angular/core';
import { WidgetStates, WorkflowWidgetState } from '../widget-context.type';
import { WidgetLoggerService } from './widget-logger.service';

@Injectable({
  providedIn: 'root'
})
export class WidgetStateService {
  public static widgetStateChange$: EventEmitter<WorkflowWidgetState> = new EventEmitter<WorkflowWidgetState>();

  public currentState: WorkflowWidgetState = {};
  constructor(private readonly widgetLoggerService: WidgetLoggerService) {}

  public updateState(state?: WidgetStates, message?: string): void {
    // this.widgetLoggerService.logMessage('Widget -> state: ', state );
    this.emitState(state, message);
  }

  private emitState(state?: WidgetStates, message?: string): void {
    this.currentState.state = state;
    this.currentState.message = message;
    WidgetStateService.widgetStateChange$.emit({ state, message });
  }
}
